import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import { CredentialPicker } from '../../../FlowConfigurationInputs/CredentialPicker/CredentialPicker';
import AutomService from '../../../../services/AutomService/AutomService';
import { isActionValueController } from '../../../../helpers/helper';

function Connect({ automId, action, variables, setOpenVariable, showAlert, automVersionId }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.ACTIVE-DIRECTORY.CONNECT.';

    const handleClick = async () => {
        let res = isActionValueController(action.fields);
        if (res.indexOf(false) === -1) {
            action.automId = automId;
            action.automVersionId = automVersionId;
            let response = await AutomService.runAction(action);
            if (response) { showAlert(t('FLOW-MESSAGES.LIBRARY.' + response.message), response.status); }
        }
        else { showAlert(t('ACTIVE-DIRECTORY.NOT-NULL'), false); }
    }

    return (
        <div>
            <div className="form-element">
                {t(label + 'PATH')}
                <TextInput action={action} inputName="path" variables={variables} setOpenVariable={setOpenVariable} isRequired
                    fieldType='string' displayName={t(label + 'PATH')} />
            </div>
            <div className="form-element">
                {t(label + 'USER')}
                <CredentialPicker action={action} inputName="loginUser" variables={variables} setOpenVariable={setOpenVariable} isRequired />
            </div>
            <div className="form-element">
                {t(label + 'PASSWORD')}
                <CredentialPicker action={action} inputName="loginPassword" variables={variables} setOpenVariable={setOpenVariable} isRequired isPassword={true} />
            </div>
            <div className="form-element">
                Base Path
                <TextInput action={action} inputName="baseDn" variables={variables} setOpenVariable={setOpenVariable} isRequired
                    fieldType='string' displayName={'Base Path'} />
                <small>dc=autommate,dc=com</small>
            </div>
            <button className="form-button" onClick={() => handleClick()}>Test Connection</button>
        </div>
    )
}

export default Connect;
